import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { SITE } from "@/data/content";

const columns = [
  {
    title: "Company",
    links: [
      { label: "Home", path: "/" },
      { label: "About", path: "/about" },
      { label: "Our Approach", path: "/approach" },
      { label: "Developments", path: "/developments" },
    ],
  },
  {
    title: "Our Focus",
    links: [
      { label: "Redevelopment", path: "/redevelopment" },
      { label: "Plotted Development", path: "/plotted-development" },
      { label: "Contact", path: "/contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", path: "/privacy-policy" },
      { label: "Terms & Conditions", path: "/terms-conditions" },
      { label: "Disclaimer", path: "/disclaimer" },
    ],
  },
];

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-ink text-white">
    <div className="mx-auto max-w-7xl px-6 py-16 lg:px-12 lg:py-20">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <Link to="/" data-testid="footer-brand" aria-label="Evaya Ventures home">
            <img
              src={SITE.logo}
              alt="Evaya Ventures Pvt. Ltd. — from Earth to Extraordinary"
              className="h-auto w-[190px]"
            />
          </Link>
          <p className="mt-5 font-display text-xl italic text-brand-light" data-testid="footer-tagline">
            {SITE.tagline}
          </p>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/55">
            An emerging real-estate development company focused on redevelopment and thoughtfully planned plotted land development.
          </p>
          <ul className="mt-6 space-y-3">
            <li>
              <a
                href={SITE.phoneHref}
                data-testid="footer-phone-link"
                className="flex items-center gap-3 text-sm text-white/75 transition-colors duration-300 hover:text-brand-light"
              >
                <Phone className="h-4 w-4 shrink-0 text-brand" strokeWidth={1.5} aria-hidden="true" />
                {SITE.phone}
              </a>
            </li>
            <li>
              <a
                href={SITE.emailHref}
                data-testid="footer-email-link"
                className="flex items-center gap-3 text-sm text-white/75 transition-colors duration-300 hover:text-brand-light"
              >
                <Mail className="h-4 w-4 shrink-0 text-brand" strokeWidth={1.5} aria-hidden="true" />
                {SITE.email}
              </a>
            </li>
          </ul>
        </div>

        {columns.map((col) => (
          <div key={col.title}>
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">{col.title}</h3>
            <ul className="mt-5 space-y-3">
              {col.links.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-sm text-white/65 transition-colors duration-300 hover:text-brand-light"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-8 text-sm text-white/45 md:flex-row md:items-center md:justify-between">
        <p data-testid="footer-copyright">© 2026 Evaya Ventures. All Rights Reserved.</p>
        <p>
          <a href={SITE.url} data-testid="footer-website-link" className="transition-colors duration-300 hover:text-brand-light">
            evayaventures.com
          </a>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
